import lang from "@/views/modules/chat/list/lang";

/**
 * 取得本地环境
 * @return {"test"|"pre"|"prod"}
 */
export function getLocalEnv() {
    // if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
    //     return 'test';
    // } else if (/^test-.*\.fastindexs\.com$/.test(location.hostname)) {
    //     return 'test';
    // } else if (/^pre-.*\.fastindexs\.com$/.test(location.hostname)) {
    //     return 'pre';
    // } else if (/.*\.fastindexs\.com$/.test(location.hostname)) {
    //     return 'prod';
    // }
    if (import.meta.env.VITE_ENV_CONFIG.includes('dev') || import.meta.env.VITE_ENV_CONFIG.includes('test')) {
        return 'test';
    } else if (import.meta.env.VITE_ENV_CONFIG.includes('pre')) {
        return 'pre';
    } else if (import.meta.env.VITE_ENV_CONFIG.includes('prod')) {
        return 'prod';
    }
}

export function getRequest() {
    let url = location.search;
    let theRequest = new Object();
    let strs;
    if (url.indexOf('?') != -1) {
        let str = url.substr(1);
        strs = str.split('&');
        for (let i = 0; i < strs.length; i++) {
            theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1]);
        }
    }
    return theRequest;
}
export function cutbytestr(str, len, flag) {
    var str_length = 0;
    var str_len = 0;
    var str_cut;
    str_cut = new String();
    str_len = str.length;
    for (var i = 0; i < str_len; i++) {
        let a = str.charAt(i);
        str_length++;
        if (escape(a).length > 4) {
            //中文字符的长度经编码之后大于4
            str_length++;
        }
        if (str_length <= len) {
            str_cut = str_cut.concat(a);
        }
    }
    if (str_length > len) {
        str_cut = str_cut.concat(flag||'.');
        return str_cut;
    }
    //如果给定字符串小于指定长度，则返回源字符串；
    if (str_length <= len) {
        return str;
    }
}
export function subStrDealUrl(str) {
    let temp = '';
    if (str) {
        temp = str.substr(0, 1) == '/' ? str : '/' + str;
    }
    return temp;
}

export function getLangNameByCode(code){
    if(code){
        let arr = lang.filter(res => res.code == code);
        if(arr.length){
            return arr[0].name;
        }else {
            return ''
        }
    }else{
        return ''
    }
}